import { applySnapshot, Instance, SnapshotIn, types } from 'mobx-state-tree';
import searchModel from '~/stores/lead/searchStore';

const IDENTIFIER = 'leadModel';

/**
 * 리드목록 모델
 */
const model = types
  .model(IDENTIFIER, {
    /** 스토어 아이덴티티 */
    identifier: types.optional(types.identifier, IDENTIFIER),
    /** 4시간 안내 스낵바 띠웠는지 여부(한번만 띄우기 위한 목적) */
    is4HourNotiUse: types.optional(types.boolean, false),
    /** 검색 모델 */
    searchModel: types.optional(searchModel.model, searchModel.defaultValue),
  })
  .actions((self) => ({
    /** 초기화 */
    setInit() {
      applySnapshot(self, {
        ...defaultValue,
        searchModel: {
          ...defaultValue.searchModel,
          searchAreaInitTrigger: !self.searchModel.searchAreaInitTrigger,
        },
      });
    },
    /** set 4시간 안내 스낵바 띠웠는지 여부 */
    set4HourNotiUse(val: boolean) {
      self.is4HourNotiUse = val;
    },
  }));

/** 초기화 값 */
const defaultValue: SnapshotIn<typeof model> = {
  identifier: IDENTIFIER,
  is4HourNotiUse: false,
  searchModel: searchModel.defaultValue,
};

/** create or initialize */
const create = model.create(defaultValue);

/** store */
const store = {
  create,
  defaultValue,
  model,
};

/** 모델 타입 */
export type ILeadModelType = Instance<typeof model>;

export default store;
